function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import classnames from "classnames";
import colors from "styles/colors";
import HeaderMenuSectionComponent from "segments/desktop/header/layouts/base-header/base-header-desktop/header-menu/sections-header-menu/header-menu-section/header-menu-section-component.js";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledStructuredHeaderMenuContentComponent } from "./structured-header-menu-content.scss";
const StructuredHeaderMenuContentComponent = (props)=>{
    const { menuId, id, content = {}, translate } = props;
    const { title: contentTitle, menuSections = [] } = content;
    const getStyle = ()=>{
        const backgroundColor = backgroundColor ? colors[backgroundColor] : "transparent";
        return {
            "--section-background-color": backgroundColor
        };
    };
    const renderHeaderMenuSections = useCallback(()=>{
        return menuSections.map((menuSection, index)=>{
            const { backgroundColor, classname, noSeparator, title } = menuSection;
            const isLastItem = menuSections.length - 1 === index;
            const hasBackgroundColor = !!backgroundColor;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("header-menu-section-component-wrapper", classname, {
                            "has-background-color": hasBackgroundColor
                        }),
                        style: getStyle(),
                        children: /*#__PURE__*/ _jsx(HeaderMenuSectionComponent, _object_spread_props(_object_spread({}, menuSection), {
                            menuId: menuId
                        }))
                    }, title),
                    !isLastItem && !noSeparator && /*#__PURE__*/ _jsx("div", {
                        className: classnames("sections-separator", classname)
                    })
                ]
            });
        });
    }, [
        menuSections
    ]);
    return /*#__PURE__*/ _jsxs(StyledStructuredHeaderMenuContentComponent, {
        className: "structured-header-menu-content",
        children: [
            contentTitle && /*#__PURE__*/ _jsx("div", {
                className: "structured-header-menu-content-title",
                children: translate(contentTitle)
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "header-menu-sections-wrapper",
                children: renderHeaderMenuSections()
            })
        ]
    });
};
export default withGenericConfig(StructuredHeaderMenuContentComponent);
